<template>
  <div class="comContent">
    <div class="topHead">
      <div>
        <span>{{ shopName }}</span>
        <span style="margin-left: 12px;color: black;font-size: 14px;font-weight: 600;">
          当前余额
          <span style="color: #F5222D;">
            ￥{{ balanceAvailable }}
          </span>
        </span>
      </div>
      <div>
        <el-button size="small" type="primary" @click="HandlerClick('余额扣减', '1')">余额扣减</el-button>
        <el-button size="small" type="primary" @click="HandlerClick('余额增额', '0')">余额增额</el-button>
      </div>
    </div>
    <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left;margin-top: 20px;">
      <el-form-item prop="id" label="">
        <el-input v-model.trim="formTool.id" placeholder="请输入记录编号" clearable size="small" />
      </el-form-item>
      <el-form-item prop="orderCode" label="">
        <el-input v-model.trim="formTool.orderCode" placeholder="请输入订单编号" clearable size="small" />
      </el-form-item>

      <el-form-item prop="extendType" label="">
        <el-select v-model="formTool.businessType" clearable style="width: 140px;" size="small" placeholder="变动原因">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="extendType" label="">
        <el-date-picker v-model="formTool.date" size="small" type="daterange" value-format="yyyy-MM-dd"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset()">重置</el-button>
      </el-form-item>

    </el-form>

    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
      :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">

      <template slot="promotionArea" slot-scope="scope">
        <span v-if="scope.row.changeAmountType == '0'" class="add"> + <span> {{ scope.row.amountChange ?
          parseFloat(scope.row.amountChange).toFixed(2) : '0.00' }}</span></span>
        <span v-if="scope.row.changeAmountType == '1'" class="reduce"> - <span>{{ scope.row.amountChange ?
          parseFloat(scope.row.amountChange).toFixed(2) : '0.00' }}</span></span>
        <br />
        <span> <span>{{ scope.row.amountBalance ? parseFloat(scope.row.amountBalance).toFixed(2) : '0.00' }}</span>
        </span>
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link v-if="scope.row.businessTypeStr == '平台增额' || scope.row.businessTypeStr == '平台扣减'" type="primary"
            :underline="false" @click="detailClick(scope.row, '客户余额详情')" style="margin-right: 10px">
            详情
          </el-link>
        </div>
      </template>
    </myTable>
    <deductionDialog ref="deductionDialog" @submit="submit" />
    <detailDialog ref="detailRef"></detailDialog>
  </div>
</template>
<script>

const options = [{
  label: '平台增额',
  value: '3'
}, {
  label: '平台扣减',
  value: '4'
}, {
  label: '订单支付',
  value: '0'
}, {
  label: '订单退款',
  value: '1'
}, {
  label: ' 超时发货赔付',
  value: '2'
}]
import myTable from "@/components/myTable";
import deductionDialog from "../component/deductionDialog.vue";
import detailDialog from "../component/detailDialog.vue";
import { giftPayeeListPlatform, getByShopId, guaranteeCustomFlowsPage, manualUpdate } from "@/api/gift";
export default {
  components: { myTable, deductionDialog, detailDialog },
  props: {},
  data () {
    return {
      balanceAvailable: '0.00',
      id: '',
      shopName: '',
      value1: [],
      options: options,
      expanded: false,
      isExpanded: false,
      loading: false,
      operation: true,
      selection: true,
      index: false,
      formTool: {},
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "记录编号", prop: "id", },
        // { label: "运营人员&联系方式", prop: "shopName", },
        { label: "变动原因", prop: "businessTypeStr" },
        { label: "变动时间", prop: "createTime", },
        { label: "订单编号", prop: "orderCode", },
        // { label: "赠品数量", prop: "qty", },
        { label: "收支/余额（元）", prop: "promotionArea", slot: true },
        // { label: "促销开始时间", prop: "startTime", },
        // { label: "促销结束时间", prop: "endTime", },
        // { label: "添加时间", prop: "createTime", },
        // { label: "审核状态", prop: "businessType", slot: true },
        { label: "操作", prop: "operation", slot: true, width: 100 },
      ],
    };
  },
  filters: {

  },
  created () {
    if (this.$route.query.shopId) {
      this.id = this.$route.query.shopId
    }
    if (this.$route.query.shopName) {
      this.shopName = this.$route.query.shopName
    }
  },
  mounted () {
    this.getList();
    // this.getByShopId()
  },
  methods: {
    // 提交
    submit (value) {
      let params = {
        amount: value.amount,
        remark: value.remark,
        changeAmountType: value.type,
        customShopId: this.id,
        customShopName: this.shopName
      }
      manualUpdate(params).then((res) => {
        if (res) {
          this.$message.success('操作成功')
          this.getList();
          // this.getByShopId()
          this.$refs.deductionDialog.handleClose()
        }
      })
    },
    // 选择商品
    chooseGood (row) {
      this.dialogVisible = true;
      this.rowData = row;
    },
    choice (val) {
      this.rowData.skuList = val
      // this.beforeClose()
    },
    getByShopId () {
      let params = {
        shopId: this.id
      }
      getByShopId(params).then((res) => {
        if (res) {
          this.balanceAvailable = res.balanceAvailable
        }
      })
    },
    getList (current) {
      if (current) {
        this.page.current
      }
      let params = {};
      params.current = this.page.current;
      params.size = this.page.size;
      params.businessType = this.formTool.businessType;
      params.id = this.formTool.id;
      params.orderCode = this.formTool.orderCode;
      params.createTimeBegin = this.formTool.date ? this.formTool.date[0] : '';
      params.createTimeEnd = this.formTool.date ? this.formTool.date[1] : '';
      params.customShopId = this.id;
      this.getByShopId()
      guaranteeCustomFlowsPage(params).then((res) => {
        // console.log(res, '--res')
        this.tableData = res.records;
        this.page.total = res.total;
      }).catch((err) => { })
    },

    goBack () {
      this.$router.back()
    },
    UpdateStatus () {

    },
    HandlerClick (title, type) {
      // this.$router.push(`./salesControl-fullGiftOps-giftDetail?id=${row.id}&type=${type}`);
      this.$refs.deductionDialog.open(title, type)
    },
    // 详情
    detailClick (row, title) {
      this.$refs.detailRef.open(row, title)
    },
    reset () {
      this.formTool = {}
      this.getList(1)
    },

  },
};
</script>
<style lang="scss" scoped>
.reduce {
  color: green;
}

.add {
  color: #F5222D;
}

.topHead {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep.el-table {
  height: calc(100% - 190px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 170px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.flex-box {
  display: flex;
  justify-content: space-between;
}
</style>
